import { Component, ViewEncapsulation, AfterViewInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Router} from "@angular/router";
import {IUserDetails} from "@irb/app.model";
import {AppService} from "@irb/app.service";
import { DialogComponent } from "@irb-common/components/dialog/dialog.component";
import { DialogInitialSetupComponent } from './dialog-initial-setup/dialog-initial-setup.component';

@Component({ standalone: false,
    selector: 'irb-initial-setup',
    templateUrl: './irb-initial-setup.component.html',
    styleUrls: ['./irb-initial-setup.component.scss'],
    encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbInitialSetupComponent implements AfterViewInit {
    @ViewChild("dialog") dialog: DialogComponent;
    
    constructor(private readonly router: Router, private as: AppService) {}

    ngAfterViewInit() {
        const userDetails:IUserDetails = this.as.getItem('IRB_APP_CONFIG');

        if (userDetails?.redirectPage === 'ADMIN_SETTINGS') {
            this.showInitialSetupDialog({
                isReadOnly: false,
                onProceed: () => this.navigateToHome(),
                onCancel: () => this.logOut()
            });
        } else if(userDetails?.redirectPage === 'NON_ADMIN_SETTINGS') {
            this.showInitialSetupDialog({
                isReadOnly: true,
                onCancel: () => this.logOut()
            });
        } else {
            this.navigateToHome();
        }
    }

    showInitialSetupDialog(data: any) {
        const config = this.dialog.getDefaultConfig();
        config.minHeight = "100px";
        config.height = "auto";
        config.width = "900px";
        config.data = data;
        config.panelClass = "irb";
        this.dialog.open(DialogInitialSetupComponent, config);
    }

    navigateToHome(){
        let userDetails = this.as.getItem("IRB_APP_CONFIG");

        if(userDetails) {
            userDetails.redirectPage = null;
        } else {
            userDetails = {};
        }

        this.as.setItem('IRB_APP_CONFIG', userDetails);

        if (userDetails.isModelProvider || userDetails.isMMCAdmin) {
            this.router.navigate(['/models/model-market-center']);
        } else {
            this.router.navigate(['/home']);
        }
    }

    logOut(){
        this.as.logOut();
    }
}

